<template>
  <div id="generate" :class="[$mq, {TA:isTestAchat}]">
    <a @click="generate()" class="button inverted" :class="[$mq === 'mobile' ? 'main' : 'secondary']">
      <SvgIcon class="icon" :icon="loading ? 'loading' : 'print'" fill :key="loading"></SvgIcon> {{ $t(`print`) }}
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters("common", ["isTestAchat"]),
    loading() {
      return (
        this.$store.state.common.printLoading
      );
    }
  },
  data: () => {
    return {
      showModal: false
    };
  },
  methods: {
    generate() {
      this.$emit("generate");
    }
  }
};
</script>

<style lang="scss" scoped>
#generate {
  .icon {
    display: inline-block;
    margin-left: 5px;
  }
  // a {
  //   .icon {
  //     font-size: 1.1rem;
  //     color: #000;
  //   }

  //   cursor: pointer;
  //   min-width: 160px;
  //   width: 160px;
  //   font-size: 0.8rem;
  //   font-weight: 600;
  //   margin: 0;
  //   padding: 10px 20px;
  //   border: 0;
  //   border: 2px solid $yellow;
  //   background: $white;
  //   border-radius: 50px;
  // }
}

.mobile .button.main {
  padding: 7px 15px;
  font-size: .7rem!important;
}

.TA {
  .button.inverted {
    text-decoration: underline $pink;
    color: $pink
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/Print.vue